module.exports = __webpack_public_path__ + "static/media/semuBizSampleFile.0ecd4343.xlsx";